export enum ExecutionModeEnum {
  MIT = "MIT",
  MOTO = "MOTO",
  TAP_INITIATED = "TAP_INITIATED",
  VAD = "VAD"
}
